import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import Header from './Header';
import Sidebar from './Sidebar';

const ReportLayout = () => {
  const reportItems = [
      { to: '/report', label: '회원별 보고서 관리' },
    ];

  return (
    <div className="wrap">
      <Header />
      <div className="section_area">
        <Sidebar items={reportItems}/>
        <div className="section_wrap">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ReportLayout;
